import { useCallback, useEffect, useMemo, useState } from "react";
import { useAppDispatch } from "../../../../app/hooks";
import { apiActions } from "../../../../slices/api-slice";
import { ApiMetaShopOrderGet, MetaShopOrderGetResponse } from "../../../../api/front/meta/api-meta-shop-order";
import { ResponseBase } from "../../../../api/response-base";
import { RoutingPath } from "../../../../routes/routing-path";
import { push } from "connected-react-router";
import { useLocation } from "react-router-dom";

type Props = {
  kijshopCd: string,
  shopOrderId: string,
}

export const useCheckOneStop = (props: Props) => {
  const {
    kijshopCd,
    shopOrderId,
  } = props;
  const [isOneStop, setIsOneStop] = useState(false);
  const location = useLocation();
  const dispatch = useAppDispatch();
  const getMeta = useCallback(() => {
    dispatch(apiActions.run(
      new ApiMetaShopOrderGet({
        kijshopCd,
        shopOrderId,
      },
    ), {
      onSuccess: (res: ResponseBase<MetaShopOrderGetResponse>) => {
        if (res.body?.data?.cfOrderId) {
          if (res.body?.data.isOneStop) {
            if (location.pathname.split('/')?.[2] !== 'one-stop') {
              dispatch(push(RoutingPath.cnv.oneStopOrdersPreparation({ kijshopCd, shopOrderId })));
            }
          } else if (res.body?.data.isOlc) {
            if (location.pathname.split('/')?.[2] !== 'ods') {
              dispatch(push(RoutingPath.cnv.olcOrdersPreparation({ kijshopCd, shopOrderId })));
            }
          } else {
            dispatch(push(RoutingPath.cnv.ordersPreparation({ kijshopCd, shopOrderId })));
          }
        }
    }}));
  }, [dispatch, kijshopCd, shopOrderId]);
  
  
  useEffect(() => {
    getMeta();
  }, [kijshopCd, shopOrderId]);
}